module.exports = __webpack_public_path__ + "img/box2-card-01.f56bfd8c.png";